import React from 'react';
import { Link } from 'react-router-dom';
import './About.css';

function About() {
  // High-quality images for the about page
  const aboutImages = [
    {
      url: 'https://i.postimg.cc/tgnRS3PC/YZ_70.jpg',
      alt: 'Ashish capturing a wedding moment',
      caption: 'Behind the lens'
    },
    {
      url: 'https://i.postimg.cc/xjHx0wfv/YZz_14.jpg',
      alt: 'Wedding couple in mountains',
      caption: 'Mountain elopement'
    },
    {
      url: 'https://i.postimg.cc/T1d66gyt/YZ_85.jpg',
      alt: 'Intimate wedding moment',
      caption: 'Quiet glances'
    }
  ];

  return (
    <div className="about-page">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="hero-overlay">
          <div className="container">
            <h1 className="hero-title">Where Love Becomes Cinema</h1>
            <p className="hero-subtitle">
              I don't just photograph weddings. I craft visual legacies.
            </p>
          </div>
        </div>
      </section>

      {/* Founder Introduction */}
      <section className="section founder-section">
        <div className="container">
          <div className="founder-grid">
            <div className="founder-content">
              <h2 className="section-title-small">Ashish</h2>
              <h3 className="founder-title">Founder & Creative Director — CineHouseStudio Canada</h3>
              <div className="founder-quote">
                <p className="lead-text">
                  I'm Ashish, the storyteller behind CineHouseStudio Canada, and my passion lies in 
                  transforming real love stories into cinematic masterpieces.
                </p>
              </div>
              <p>
                Every wedding is a once-in-a-lifetime film unfolding in real time — filled with raw emotion, 
                quiet glances, powerful vows, and electric celebrations.
              </p>
              <p className="highlight-text">
                My job? To capture it with intention, artistry, and soul.
              </p>
            </div>
            <div className="founder-image">
              <div className="image-frame">
                <img 
                  src="https://images.unsplash.com/photo-1537633552985-df8429e8048b?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80" 
                  alt="Ashish - Founder of CineHouseStudio"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Philosophy Section - The Art of Cinematic Storytelling */}
      <section className="section philosophy-section accent-bg">
        <div className="container">
          <h2 className="section-title">The Art of Cinematic Storytelling</h2>
          <div className="philosophy-content">
            <blockquote className="large-quote">
              "At CineHouseStudio, we don't chase poses. We chase moments."
            </blockquote>
            
            <div className="moments-grid">
              <div className="moment-item">
                <p>The tear your father hides.</p>
              </div>
              <div className="moment-item">
                <p>The nervous smile before you walk down the aisle.</p>
              </div>
              <div className="moment-item">
                <p>The way your partner looks at you when no one else is watching.</p>
              </div>
            </div>
            
            <p className="emphasis-text">
              These are not photographs. They are memories, preserved in their purest form.
            </p>
          </div>
        </div>
      </section>

      {/* Style Section */}
      <section className="section style-section">
        <div className="container">
          <h2 className="section-title">My Style Blends</h2>
          <div className="style-grid">
            <div className="style-card">
              <span className="style-emoji">✨</span>
              <h3>Cinematic Composition</h3>
            </div>
            <div className="style-card">
              <span className="style-emoji">📸</span>
              <h3>Documentary-style Candids</h3>
            </div>
            <div className="style-card">
              <span className="style-emoji">👑</span>
              <h3>Luxury Editorial Elegance</h3>
            </div>
            <div className="style-card">
              <span className="style-emoji">💫</span>
              <h3>Emotional Storytelling</h3>
            </div>
          </div>
          <p className="style-footer">
            Every frame is designed to feel like a still from your own love story.
          </p>
        </div>
      </section>

      {/* Image Gallery */}
      <section className="section gallery-section">
        <div className="container">
          <div className="about-gallery">
            {aboutImages.map((image, index) => (
              <div key={index} className="gallery-item">
                <img src={image.url} alt={image.alt} />
                <div className="gallery-caption">{image.caption}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Refined Experience */}
      <section className="section experience-section accent-bg">
        <div className="container">
          <h2 className="section-title">A Refined Experience</h2>
          <div className="experience-content">
            <p className="lead-text">
              Luxury is not just about visuals — it's about how you feel.
            </p>
            <p>
              From our first conversation to the final delivery, I ensure a seamless, 
              personalized experience. Calm energy. Creative direction when needed. 
              Space for authenticity when it matters most.
            </p>
            <p>
              Whether it's an intimate elopement in the mountains of Canada or a grand, 
              multi-day celebration, I approach every wedding with the same commitment:
            </p>
            <p className="highlight-text">
              To create something timeless.
            </p>
          </div>
        </div>
      </section>

      {/* Philosophy */}
      <section className="section">
        <div className="container">
          <div className="philosophy-box">
            <h2 className="section-title">The Philosophy</h2>
            <blockquote className="philosophy-quote">
              <p>Years from now, when trends fade and styles change, your photographs should still feel powerful.</p>
              <p>They should remind you not only how it looked — but how it felt.</p>
            </blockquote>
            <p className="signature-text">That is the CineHouseStudio promise.</p>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="section cta-section">
        <div className="container">
          <div className="cta-box">
            <h2>Let's Create Something Iconic</h2>
            <p>
              If you believe your wedding deserves more than just coverage —<br />
              if you want it captured like a film, remembered like art, and felt forever —
            </p>
            <p className="cta-final">Let's tell your story.</p>
            <Link to="/contact" className="button button-large">
              Inquire Now
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default About;